import { useTranslation } from "react-i18next";
import { CustomButton } from "../../components";
import "./styles.scss";
import { HEADER } from "../../constants";
import { getSessionStorage } from "../../utils/storageUtils";

const BackButtonConfirmation = ({ show, onClickCancel, onClickConfirm }) => {
  const { t } = useTranslation();
  const product = getSessionStorage(HEADER.PRODUCT_SLUG);

  if (!show) {
    return null;
  }

  return (
    <div className="back-button-confirmation-container">
      <div className="back-button-confirmation-content">
        <h1 className="heading">
          {t(
            product === "stp-pos-financing-lender"
              ? "back_button_confirmation.select_bank_heading"
              : "back_button_confirmation.heading"
          )}
        </h1>
        <p className="description">
          {t(
            product === "stp-pos-financing-lender"
              ? "back_button_confirmation.select_bank_description"
              : "back_button_confirmation.description"
          )}
        </p>
        <div className="custom-button-wrapper">
          <CustomButton
            text={t("back_button_confirmation.cancel")}
            btnVariant="btn-primary-50"
            onClick={onClickCancel}
          />
          <CustomButton text={t("global.confirm")} onClick={onClickConfirm} />
        </div>
      </div>
    </div>
  );
};

export default BackButtonConfirmation;
